import React from "react";

// Item-level Takeout marker (Sep 2026).
//
// A Dine-In customer can ask for individual items to be packed to take
// away while the order itself stays Dine-In. This badge is how that
// reads on every surface the item appears on — the cart, the checkout
// review, the customer's confirmation/status details, the tenant's
// Retail Order details, the Kitchen Display and the printable receipt.
//
// TEXT, not colour alone: a kitchen tablet in a bright room and a
// screen reader both have to get the same information. `dark` inverts
// it for the storefront's dark cart panel.
//
// It is INFORMATIONAL. Nothing about it changes price, tax, payment,
// scheduling, the order's fulfillment mode or any KDS state — see
// `backend/retail/cart.py::set_item_takeout`.
export default function TakeoutBadge({ dark = false, testId }) {
  return (
    <span
      data-testid={testId || "retail-item-takeout-badge"}
      className={
        "inline-flex items-center shrink-0 rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider border "
        + (dark
          ? "bg-amber-400/15 text-amber-200 border-amber-300/40"
          : "bg-amber-100 text-amber-800 border-amber-300")
      }
      title="Pack this item to take away"
    >
      Takeout
    </span>
  );
}
